import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../header/Header';
import { Popups } from './popups/Popups';
import {useAppSelector} from "common/hook";
import {RoleType} from "app/user-reduser";
import {ROLE_ADMIN, ROLE_DEV} from "entities/constants/constants";
import {ScrollToTop} from "../../common/hook/scrollToTop";

const Layout = () => {
    const userSuccess = localStorage.getItem('user_success');
    let role: RoleType | null = null;
    const userString = localStorage.getItem('user');

    if (userString !== null) {
        const userObject = JSON.parse(userString);
        role = userObject.role as RoleType;
    } else {
        console.error('No user data found in localStorage');
    }


    const isDev = (role === ROLE_DEV || role === ROLE_ADMIN);
    return (
        <div className={`${userSuccess && !isDev ? 'app' : ''}`}>
            <ScrollToTop/>
            <Header />
            <Outlet />
            <Popups />
        </div>
    );
};

export default Layout;


